import { CSSValue } from '../interfaces/css-value.type';

export enum VexTheme {
  DEFAULT = 'vex-theme-default',
  VL = 'vex-theme-vl',
  DODDLY = 'vex-theme-doddly',
  ONELOGINLY = 'vex-theme-oneloginly',
  SUBSCRIBLY = 'vex-theme-subscribly',
  SHAREABLY = 'vex-theme-shareably',
  SCHEDULY = 'vex-theme-scheduly',
  APPROVALY = 'vex-theme-approvaly',
  VENDILY = 'vex-theme-vendily'
}

export enum VexConfigName {
  apollo = 'apollo',
  zeus = 'zeus',
  hermes = 'hermes',
  poseidon = 'poseidon',
  ares = 'ares',
  ikaros = 'ikaros',
  vl = 'vl'
}

export enum VexColorScheme {
  LIGHT = 'light',
  DARK = 'dark'
}

export interface VexConfig {
  id: VexConfigName;
  name: string;
  bodyClass: string;
  imgSrc: string;
  direction: 'ltr' | 'rtl';
  style: {
    themeClassName: string;
    colorScheme: VexColorScheme;
    borderRadius: CSSValue;
    button: {
      borderRadius: CSSValue | undefined;
    };
  };
  layout: 'vertical' | 'horizontal';
  boxed: boolean;
  sidenav: {
    title: string;
    imageUrl: string;
    showCollapsePin: boolean;
    user: {
      visible: boolean;
    };
    search: {
      visible: boolean;
    };
    state: 'expanded' | 'collapsed';
  };
  toolbar: {
    fixed: boolean;
    user: {
      visible: boolean;
    };
  };
  navbar: {
    position: 'below-toolbar' | 'in-toolbar';
  };
  footer: {
    visible: boolean;
    fixed: boolean;
  };
}

export type VexConfigs = Record<VexConfigName, VexConfig>;

export interface VexThemeProvider {
  name: string;
  className: string;
}
